/**
 * Subdomain detection utility for wedding URLs.
 * Detects if the current page is served from a wedding subdomain (e.g., sarah-michael.ourday.my.id).
 */

const RESERVED_SUBDOMAINS = new Set([
  'www', 'api', 'cdn', 'mail', 'smtp', 'ftp', 'admin',
  'dashboard', 'app', 'staging', 'dev', 'test', 'ns1', 'ns2',
  'demo', 'help', 'support', 'status', 'blog', 'docs',
]);

const BASE_DOMAIN = 'ourday.my.id';

/**
 * Detect if the current page is on a valid wedding subdomain.
 * @returns {string|null} The subdomain string, or null if on the main domain.
 *
 * Examples:
 *   sarah-michael.ourday.my.id  =>  "sarah-michael"
 *   ourday.my.id                =>  null
 *   www.ourday.my.id            =>  null (reserved)
 *   localhost:4028              =>  null
 */
export function detectWeddingSubdomain() {
  const hostname = window.location.hostname;

  // Must end with .ourday.my.id
  if (!hostname.endsWith(`.${BASE_DOMAIN}`)) {
    return null;
  }

  // Extract subdomain part
  const subdomain = hostname.slice(0, -(BASE_DOMAIN.length + 1));

  // Must be single-level (no dots), non-empty, and not reserved
  if (!subdomain || subdomain.includes('.') || RESERVED_SUBDOMAINS.has(subdomain)) {
    return null;
  }

  return subdomain;
}
